/* eslint no-unused-expressions: 0 */
import { checkVisibility } from './checkVisibility';
import { htmlSelectors } from '../constants';
import { shouldTrackImpressions } from './impressionHelpers';
import { getUrlParams } from './helpers';

function checkOnLoad() {
  checkVisibility();
  setTimeout(checkOnLoad, 50);
}
export const initImpressionWatchers = (() => {
  let areGlobalListenersAdded = false;

  return (componentsToWatchKeys) => {
    if (typeof window !== 'undefined') {
      const queryParams = getUrlParams(window?.location?.href);
      if (shouldTrackImpressions(queryParams)) {
        if (!areGlobalListenersAdded) {
          window.addEventListener('resize', () => checkVisibility());
          window.addEventListener('scroll', () => checkVisibility());
          window.addEventListener('load', () => {
            checkOnLoad();
            initImpressionWatchers(componentsToWatchKeys);
          });
          areGlobalListenersAdded = true;
        }

        componentsToWatchKeys?.forEach((key) => {
          const component = document.querySelector(htmlSelectors[key]);

          if (component && component?.getAttribute('data-impression-handler-attached') !== 'true') {
            component.addEventListener('transitionend', () => checkVisibility(htmlSelectors[key]));
            component.setAttribute('data-impression-handler-attached', 'true');
          }
        });
      }
    }
  };
})();

export const initHeroImpressionWatchers = (() => {
  let heroCarouselWrapper = document.querySelector(htmlSelectors.NUCLEUS_HERO_WRAPPER)?.parentNode?.parentNode;
  heroCarouselWrapper?.addEventListener('transitionend', () => checkVisibility());
});
